//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QR from 'qrcode.vue';
import lottie from 'lottie-web';
import dayjs from 'dayjs';
import * as api from '~/api/index';
import hkSidebar from '~/components/public/hk-sidebar';
import initTime from '~/plugins/initTime';
import searchInput from '~/components/public/input';
import LogoBtn from '~/components/public/logo-btn.vue';
import LiveItem from '~/components/live/live-item.vue';
import noneData from '~/components/public/none-data.vue';
import IndexHomedata from '~/components/index/home-data.vue';
import { LIVECATEGORY } from '~/constants';
import AdListItemMixins from '~/mixins/ad-list-item';
import selectTab from '~/components/public/select-tab.vue';
export default {
  components: {
    hkSidebar,
    searchInput,
    LogoBtn,
    LiveItem,
    noneData,
    QR,
    IndexHomedata,
    selectTab,
  },
  mixins: [AdListItemMixins],
  async asyncData({ $axios, route, params }) {
    const { channelId } = route.query;

    const dtbData = await $axios(
      api.getDtbList({
        channel: channelId || 'all',
        liveChannelId: 'all',
        limit: 15,
      })
    );
    let data = [];
    let isMore = true;
    if (dtbData.statusCode === 200) {
      data = dtbData.result || [];
    }
    if (data.length === 0) {
      isMore = false;
    }
    return {
      data,
      isMore,
      channelId: channelId || 'all',
    };
  },
  data() {
    return {
      pageName: '直播列表',
      liveCategory: [],
      dataTimeout: null, // 延时加载数据
      dataTimeInterval: null, // 数据更新定时器
      realTimeInterval: null, // 实时时间定时器
      lastType: 'new',
      realTime: null,
      keyword: null, // 查询关键字
      dateRange: [], // 日期选中值
      dateFocus: false, // 日期组件是否聚焦
      isLoading: false, // 加载状态
      isSearch: false,
      liveChannelId: 'all',
      totalNum: 0, // 搜索总数
      searchPage: 1, // 当前页数
      lastKeyword: null, // 上一个关键词
      stockCodes: [], // 相关股票数据
      stocksInfo: [], // 接口返回的股票信息
      isShowWxQrcode: '', // 是否展示微信二维码
      qrSource: '微信二维码',
      category: 'all',
      thirdAd: null,
      sixthAd: null,
    };
  },
  head() {
    return {
      title: '格隆汇快讯-7x24小时市场快讯-财经市场热点',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            '格隆汇快讯栏目提供外汇投资实时行情,外汇投资交易,外汇投资炒股,证券等内容,实时更新,格隆汇未来将陆续开通台湾、日本、印度、欧洲等市场.',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: '外汇投资实时行情,外汇投资交易,外汇投资炒股,证券',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://www.gelonghui.com/live/',
        },
        {
          rel: 'alternate',
          media: 'only screen and (max-width:640px)',
          href: 'https://m.gelonghui.com/live/',
        },
      ],
    };
  },
  computed: {
    /**
     * @description 判断是否选择了日期
     * @returns { Boolean } 判断结果
     */
    showPicker() {
      return this.dateRange && this.dateRange.length === 2 && this.dateRange[0];
    },
    /**
     * @description 格式化日期展示
     * @returns { String } 格式化文案
     */
    formatDate() {
      if (this.showPicker) {
        return `${dayjs(this.dateRange[0]).format('YYYY-MM-DD')} - ${dayjs(
          this.dateRange[1]
        ).format('YYYY-MM-DD')}`;
      }
      return '日期筛选';
    },
    /**
     * @description 格式化展示数据列
     * @returns { Array } 格式化数据列
     */
    dataList() {
      const stockCodes = [];
      const data = this.data.map((item, index) => {
        if (item.relatedStocks && item.relatedStocks.length > 0) {
          item.relatedStocks.forEach(stock => {
            if (!stockCodes.includes(`${stock.market}${stock.code}`)) {
              stockCodes.push(`${stock.market}${stock.code}`);
            }
          });
        }
        const obj = Object.assign({}, item);
        obj.isnewDate = obj.isnewDate || false;
        obj.isShowImg = false;
        obj.liveLink = `https://m.gelonghui.com/live/${obj.id}`;
        obj.weiboshare = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
          'https://m.gelonghui.com/dtb/'
        )}${obj.createTimestamp}/${obj.id}&title=【格隆汇快讯】${
          obj.content
        }&searchPic=false`;
        if (index === 0) {
          if (
            dayjs(obj.createTimestamp * 1000).format('M-D') !==
            dayjs().format('M-D')
          ) {
            obj.isnewDate = true;
          }
        }
        if (index < this.data.length - 1) {
          if (
            dayjs(obj.createTimestamp * 1000).format('M-D') !==
            dayjs(this.data[index + 1].createTimestamp * 1000).format('M-D')
          ) {
            this.data[index + 1].isnewDate = true;
          }
        }
        return obj;
      });
      this.stockCodes = stockCodes;

      return this.insertAdToData(data, this.live_ad, 2, 6);
    },
    /**
     * @description 股票数据枚举
     * @returns { Object } 格式化枚举
     */
    stocksObj() {
      const obj = {};
      if (this.stocksInfo) {
        this.stocksInfo.forEach(item => {
          obj[`${item.market.toLowerCase()}${item.code}`] = item;
        });
      }
      return obj;
    },
  },
  watch: {
    /**
     * @description 监听股票数组的变化
     * @param { Array } 最新值
     */
    stockCodes(val) {
      if (val && val.length > 0) {
        this.getStockCodes(val);
      }
    },
    $route: {
      handler(value) {
        this.channelId = value.query.channelId;
        this.getList('reset');
      },
      deep: true,
    },
  },
  mounted() {
    this.liveCategory = LIVECATEGORY;

    lottie.loadAnimation({
      container: document.getElementById('live-gif'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/svg-icon/live-img.json',
    });
    clearTimeout(this.dataTimeout);
    clearInterval(this.realTimeInterval);
    clearInterval(this.dataTimeInterval);
    this.realTime = this.initTime().format('M月D日  星期W  H:m');
    this.realTimeInterval = setInterval(() => {
      this.realTime = this.initTime().format('M月D日  星期W  H:m');
    }, 1000);
    this.dataTimeout = setTimeout(() => {
      // 30秒才执行获取列表数据方法
      this.getList('reset');
    }, 30000);
  },
  beforeDestroy() {
    // this.$Logan.report()
    clearTimeout(this.dataTimeout);
    clearInterval(this.realTimeInterval);
    clearInterval(this.dataTimeInterval);
  },
  methods: {
    /**
     * @description 修改快讯类型
     * @param { String } type 类型
     */
    changeCategory(type) {
      this.getList('reset');
    },
    /**
     * @description 打开微信分享
     * @param { i } 分享二维码
     */
    openwxshare(i) {
      this.isShowWxQrcode = true;
      this.qrSource = encodeURI(i);
      document.body.style.overflow = 'hidden';
    },
    /**
     * @description 关闭微信分享
     */
    closewxshare() {
      this.isShowWxQrcode = false;
      this.qrSource = '';
      document.body.style.overflow = '';
    },
    /**
     * @description 获取相关的股票数据
     * @param { Array } codes 请求的股票数组
     */
    async getStockCodes(codes) {
      const data = await this.$axios(
        api.getStockPriceInfo({
          stocks: codes.toString(),
        })
      );
      if (data.statusCode === 200) {
        this.stocksInfo = data.result || [];
      }
    },
    /**
     * @description 点击触发日期下拉选项
     */
    showDate() {
      this.$refs.elDatePicker.focus();
    },
    /**
     * @description 格式化时间
     * @param { Object } t 时间对象
     * @returns { Object } 格式化实例
     */
    initTime(t) {
      return initTime(t);
    },
    /**
     * @description 加载更多列表
     * @param { String } reset 是否重置
     * @param { Boolean } isMore 是否为加载更多
     */
    async getList(reset, isMore = false) {
      if (this.isLoading) {
        return false;
      }
      this.isMore = true;
      clearTimeout(this.dataTimeout);
      clearInterval(this.dataTimeInterval);
      const query = {
        channel: this.channelId,
      };
      this.isSearch = false;
      let isSearch = false;
      if (this.showPicker) {
        query.startTimestamp =
          new Date(this.dateRange[0]).getTime() / 1000 || null;
        query.endTimestamp =
          parseInt(new Date(this.dateRange[1]).getTime() / 1000) +
            60 * 60 * 24 -
            1 || null;
      }
      if (this.showPicker || this.keyword) {
        isSearch = true;
      }
      if (isSearch) {
        // 存在筛选项搜索历史数据
        this.category = 'all';
        query.keyword = this.keyword;
        await this.searchLive(query, isMore);
        this.isSearch = true;
      } else {
        // 获取实时新闻
        this.lastKeyword = null;
        this.totalNum = 0;
        this.searchPage = 1;
        if (!isMore) {
          query.liveChannelId = this.liveChannelId; // 用于判断是获取最新，还是加载更多
        } else {
          query.liveId = this.data[this.data.length - 1].id;
        }
        query.limit = 15;
        query.category = this.category;
        await this.getNewDtbData(query, reset);
        this.dataTimeInterval = setInterval(() => {
          this.getList();
        }, 30000);
      }
      this.lastType = isSearch ? 'search' : 'new'; // 记录上次搜索类型
    },
    /**
     * @description 获取实时新闻
     * @param { Object } query 请求参数
     * @param { Boolean } reset 是否重置
     */
    async getNewDtbData(query, reset) {
      this.isLoading = true;
      const dtbData = await this.$axios(api.getDtbList(query)).catch(() => ({
        statusCode: 400,
        message: '接口数据错误',
        result: [],
      }));
      this.isLoading = false;
      if (dtbData?.statusCode === 200) {
        const data = dtbData?.result || [];
        if (data.length === 0) {
          this.isMore = false;
        }
        if (reset === 'reset' || this.lastType !== 'new') {
          // 获取最新数据
          this.data = data;
        } else if (query.liveChannelId) {
          // 判断是否加载更多,是?获取最新的数据插入数组前面, 否?则完全更新数据
          const oldNewsestDataCreateTime = this.data[0].createTimestamp; // 旧数据最新的那一条的id
          const newsData = data.filter(item => {
            // 最新的数据则是大于旧数据最新的id
            return item.createTimestamp > oldNewsestDataCreateTime;
          });
          if (newsData && newsData.length > 0) {
            // 把最新数据插入就数据最前面
            this.data.unshift(...newsData);
          }
        } else if (query.liveId) {
          // 获取更多
          this.data.push(...data);
        }
      }
    },
    /**
     * @description 搜索新闻
     */
    async searchLive(query, isMore) {
      if (isMore && query.keyword === this.lastKeyword) {
        // 上一次查询关键词等于当前关键词点击加载更多为翻页
        this.searchPage++;
      } else {
        // 新开页
        this.searchPage = 1;
        this.data = [];
      }
      query.page = this.searchPage;
      query.count = 15;
      this.isLoading = true;
      const dtbData = await this.$axios(api.searchSolrLive(query));
      this.lastKeyword = query.keyword;
      this.isLoading = false;
      this.totalNum = dtbData.totalCount;
      const data = dtbData.result || [];
      if (data.length === 0) {
        this.isMore = false;
      }
      if (data && data.length > 0) {
        this.data.push(...data);
      } else if (isMore) {
        // 获取更多不作为
        // eslint-disable-next-line no-console
        console.log('isMore');
      } else {
        this.data = [];
      }
    },
  },
};
